import { BaseItem, ColumnDefinition } from '@approvalmax/ui/src/components';

import { messages } from './AddBillsPopup.messages';
import { SortingConfig, TableColumns } from './AddBillsPopup.types';

export const getColumns = (sortingConfig?: SortingConfig): ColumnDefinition<BaseItem>[] => [
    {
        id: TableColumns.dateDue,
        name: messages.dateDueColumnName,
        sortable: true,
        sortOrder: sortingConfig?.sortBy === TableColumns.dateDue ? sortingConfig.sortOrder : undefined,
    },
    {
        id: TableColumns.type,
        name: messages.typeColumnName,
    },
    {
        id: TableColumns.reference,
        name: messages.referenceColumnName,
        sortable: true,
        sortOrder: sortingConfig?.sortBy === TableColumns.reference ? sortingConfig.sortOrder : undefined,
    },
    {
        id: TableColumns.originalAmount,
        name: messages.originalAmountColumnName,
        sortable: true,
        sortOrder: sortingConfig?.sortBy === TableColumns.originalAmount ? sortingConfig.sortOrder : undefined,
        textAlign: 'right',
        headerTextAlign: 'right',
    },
    {
        id: TableColumns.amountDue,
        name: messages.amountDueColumnName,
        sortable: true,
        sortOrder: sortingConfig?.sortBy === TableColumns.amountDue ? sortingConfig.sortOrder : undefined,
        textAlign: 'right',
        headerTextAlign: 'right',
    },
    {
        id: TableColumns.currency,
        name: messages.currencyColumnName,
    },
    {
        id: TableColumns.discountDate,
        name: messages.discountDateColumnName,
        sortable: true,
        sortOrder: sortingConfig?.sortBy === TableColumns.discountDate ? sortingConfig.sortOrder : undefined,
    },
    {
        id: TableColumns.discountAvailable,
        name: messages.discountAvailableColumnName,
        sortable: true,
        sortOrder: sortingConfig?.sortBy === TableColumns.discountAvailable ? sortingConfig.sortOrder : undefined,
        textAlign: 'right',
        headerTextAlign: 'right',
    },
];
